// import { emailENUM } from "@/erp/sale/asesor";
import {
  BucketAwtENUM,
  EstadoOTPChoiceEnum,
  getEnvs,
  hasPermission,
  IvaENUM,
  newPreventaSchema,
  obtenerPromocionDePrioridadMasBaja,
  obtenerUbicacion,
  ROUTER_PATHS,
  texto,
  TipoContribuyenteRucChoice,
  TipoFormaPagoEnumChoice,
  TipoIdentificacionEnumChoice,
  TipoReferidoEnumChoice,
  TipoServicioEnumChoice,
  useLoaders,
  useMapComponent,
  useUploadFile,
  ValorRadioBase,
} from "@/shared";
import {
  getAplicaPromocion,
  getProspectoByIdProspecto,
  postPoligono,
  putCodigoOTP,
  searchDataByCedulaDirecto,
  updateProspecto,
  useCreatePreventa,
  useFetchCalcularValorInstalacion,
  useFetchEntidadesFinancieras,
  useFetchEsClienteFibramax,
  useFetchFlota,
  useFetchGenerarCodigoOtp,
  useFetchParametros,
  usePostValidarCodigoOtp,
  usePutFetchCodOtp,
  useUpdatePreventa,
} from "@/shared/actions/erp";
import { useFetchCooperativa } from "@/shared/actions/erp/cooperativa.actions";
// import { useLocalidad } from "@/shared/hooks/useLocalidad";
import { PermissionsEnum } from "@/auth/interfaces";
import { emailENUM } from "@/erp/sale/asesor";
import { getPaymentMethodsV2 } from "@/shared/actions/erp";
import useAutocompleteFetch from "@/shared/hooks/useAutocompleteFetch";
import { useLocalidad } from "@/shared/hooks/useLocalidad";
import {
  AlertSeverityEnum,
  EntidadesFinancieras,
  IDataPreventa,
  IDataProspecto,
  IFormPreventa,
  IPaymentMethod,
  PaymentMethodEnum,
  Plan,
  ServciceTypeEnum,
  TipoContratoENUM,
  TipoSolicitudesEnum,
} from "@/shared/interfaces";
import {
  IPaymentMethodV2,
  TipoPagoV2Enum,
} from "@/shared/interfaces/erp/system-settings";
import { useEquiposAdicionales } from "@/store/erp";
import { usePlanStore } from "@/store/erp/system-settings/plan.store";
import { useUiStore } from "@/store/ui";
import { yupResolver } from "@hookform/resolvers/yup";
import CardValidator from "card-validator";
import { useCallback, useEffect, useMemo, useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
const { VITE_NODE_ENV } = getEnvs();

enum DocKey {
  IDENTIFICACION_FRONTAL = "IDENTIFICACION FRONTAL",
  IDENTIFICACION_REVERSO = "IDENTIFICACION REVERSO",
  RUC = "RUC",
  NOMBRAMIENTO = "NOMBRAMIENTO",
  DEBITO = "DEBITO",
  TARJETA = "TARJETA",
}
interface useFormPreventaProps {
  dataProspecto: IDataProspecto;
  editSupervisor: boolean;
  dataPreventa?: IDataPreventa;
}

export const useFormPreventa = ({
  dataProspecto,
  editSupervisor,
  dataPreventa,
}: useFormPreventaProps) => {
  const planRRHH =
    VITE_NODE_ENV == "prod"
      ? hasPermission(PermissionsEnum.custom_plan_rrhh)
      : false;

  const navigate = useNavigate();

  ///* state
  const [modalMapa, setModalMapa] = useState<boolean>(false);
  const [existeCobertura, setExisteCobertura] = useState<boolean>(false);
  const [tipoTarjeta, setTipoTarjeta] = useState<string | null>(null);
  const [planDiscTerEdad, setPlanDiscTerEdad] = useState<boolean>(false);
  const [visibleReferido, setVisibleReferido] = useState<boolean>(false);
  const [esReferido, setEsReferido] = useState<number>(404);
  const [imgCedulaFrontal, setImgCedulaFrontal] = useState<File | null>(null);
  const [imgCedulaReverso, setImgCedulaReverso] = useState<File | null>(null);
  const [imgCuentaBancaria, setImgCuentaBancaria] = useState<File | null>(null);
  const [imgTarjeta, setImgTarjeta] = useState<File | null>(null);
  const [imgRUC, setImgRUC] = useState<File | null>(null);
  const [imgRUCNombramiento, setImgRUCNombramiento] = useState<File | null>(
    null,
  );
  const [referidoTemp, setReferidoTemp] = useState<string | null | undefined>(
    null,
  );
  const [validoCodigoOTP, setValidoCodigoOTP] = useState<boolean | null>(
    VITE_NODE_ENV != "prod",
  );
  const [idCodigoSMS, setIdCodigoSMS] = useState<string>();
  const [openOtp, setOpenOtp] = useState<boolean>(false);
  const [countdownInterval, setCountdownInterval] =
    useState<NodeJS.Timeout | null>(null);
  const [countdown, setCountdown] = useState<number>(600); //600 = 10 minutos
  const [timeoutId, setTimeoutId] = useState<NodeJS.Timeout | null>(null);
  const [valueOtp, setValueOtp] = useState<string>("");

  // V2 - 3 niveles de pago
  const [entidadesV2Filtradas, setEntidadesV2Filtradas] = useState<
    EntidadesFinancieras[]
  >([]);
  const [isLoadingEntidadesV2, setIsLoadingEntidadesV2] =
    useState<boolean>(false);
  const [formasPagoV2Filtradas, setFormasPagoV2Filtradas] = useState<
    IPaymentMethodV2[]
  >([]);
  const [isLoadingFormasPagoV2, setIsLoadingFormasPagoV2] =
    useState<boolean>(false);
  const [selectedCardTypeName, setSelectedCardTypeName] = useState<
    string | null
  >(null);
  const [valorRestriccionCel, setValorRestriccionCel] = useState<any>({});

  ///* store
  const { fetchAutocompleteEmpleado } = useAutocompleteFetch();

  const plans = usePlanStore((s) => s.plans);
  const setAlert = useUiStore((s) => s.setAlert);

  const handleCargaInicial = async () => {
    if (dataProspecto.codigo_otp != null) setValidoCodigoOTP(true);

    ///* cargar plan si esta tercera edad o discapacitado

    const tieneBeneficio = [
      dataProspecto.es_tercera_edad,
      dataProspecto.es_discapacitado,
      dataProspecto.es_curador_tutor,
      dataProspecto.es_ayuda_social,
      dataProspecto.es_bono_humano,
      dataProspecto.es_gremio,
      planRRHH,
    ].some(Boolean);

    if (tieneBeneficio) {
      const {
        es_tercera_edad,
        es_discapacitado,
        es_curador_tutor,
        es_ayuda_social,
        es_bono_humano,
        es_gremio,
      } = dataProspecto;

      es_tercera_edad &&
        setAlert(true, texto.persona_tercera_edad, AlertSeverityEnum.info);

      es_discapacitado &&
        setAlert(true, texto.persona_con_discapacidad, AlertSeverityEnum.info);

      form.setValue("es_discapacitado", es_discapacitado);
      form.setValue("es_tercera_edad", es_tercera_edad);

      console.log("planRRHH", planRRHH);

      const plan = plans.find(
        (p) =>
          (es_tercera_edad && p.es_tercera_edad) ||
          (es_discapacitado && p.es_discapacidad) ||
          (es_curador_tutor && p.es_curador_tutor) ||
          (es_ayuda_social && p.es_ayuda_social) ||
          (es_bono_humano && p.es_bono_humano) ||
          (es_gremio && p.es_gremio) ||
          (planRRHH && p.es_rrhh),
      );

      const respPromocion = await getAplicaPromocion({
        planes: plan?.codigo,
        estado: true,
      });

      if (plan) {
        reset({
          ...form.getValues(),
          tipo_plan: plan.tipo_plan,
          tipo_servicio: plan.tipo_servicio,
          plan: plan?.codigo,
          velocidad: plan.velocidad_subida_maxima,
          unidad: plan.unidad,
          valor_plan: plan?.valor,
          promocion:
            respPromocion.length != 0 ? respPromocion[0].id_promocion : "",
        });
      }

      setPlanDiscTerEdad(es_tercera_edad || es_discapacitado);
    } else {
      reset({
        ...form.getValues(),
        es_discapacitado: false,
        es_tercera_edad: false,
        tipo_plan: "",
        tipo_servicio: "",
        plan: "",
        velocidad: "",
        unidad: "",
        valor_plan: "",
        promocion: "",
      });

      setPlanDiscTerEdad(false);
    }

    ///* obtener ubicacion actual

    if (!editSupervisor) {
      const { solictud_canje_data, solictud_evento_data } = dataProspecto;

      if (solictud_canje_data) {
        await handleUbicacionDefecto(
          dataProspecto.solictud_canje_data.coordenadas,
        );
        return;
      }

      if (solictud_evento_data) {
        await handleUbicacionDefecto(
          dataProspecto.solictud_evento_data.coordenadas,
        );
        return;
      }

      //handleApiUbicacioActual();
      form.setValue("coordenadas", "");
    }

    ///* cargar preventa
    if (editSupervisor) {
      ///* equipos adicional

      handleSetAllProductos(dataPreventa?.equipos_adicionales ?? []);
      ///* referido
      form.setValue("codigo_refiere", dataPreventa?.referido_cliente);
      dataPreventa?.referido_cliente && setVisibleReferido(true);
      setReferidoTemp(dataPreventa?.referido_cliente);

      ///* ubicación
      await handleUbicacionDefecto(dataPreventa?.coordenadas!);

      if (form.getValues().zona) {
        reset({
          ...form.getValues(),
          ...dataPreventa,
          email_temporal: dataPreventa?.email.split("@").at(0),
          servicio_correo: `@${dataPreventa?.email.split("@").at(1)}`,
          forma_pago: dataPreventa?.forma_pago_data?.forma_pago,
          observacion_1: dataPreventa?.observaciones.observacion_1,
          observacion_2: dataPreventa?.observaciones.observacion_2,
          codigo_forma_pago: dataPreventa?.forma_pago_data?.codigo,
          tipo_identificacion_factura: dataProspecto.tipo_identificacion,
          razon_social_factura: dataProspecto.razon_social,
          // V2 - Cargar datos de pago V2 si existen
          tipo_pago_v2: dataPreventa?.tipo_pago_v2 ?? "",
          entidad_financiera: dataPreventa?.entidad_financiera ?? "",
          forma_pago_v2: dataPreventa?.forma_pago_v2 ?? "RECAUDACIÓN", // Para mantener compatibilidad con preventas antiguas que solo tenían forma_pago_legacy
          forma_pago_legacy:
            dataPreventa?.forma_pago_v2_data?.forma_pago_legacy ?? null,
          tarjeta:
            dataPreventa?.forma_pago_v2_data?.forma_pago_legacy_data?.tarjeta ??
            dataPreventa?.tarjeta ??
            null,
        } as any);

        // V2: Si hay tipo_pago_v2, cargar las opciones de entidades y formas de pago
        if (dataPreventa?.tipo_pago_v2) {
          // Cargar entidades (sin hacer reset del formulario)
          setIsLoadingEntidadesV2(true);
          try {
            const res = await getPaymentMethodsV2({
              tipo_pago: dataPreventa.tipo_pago_v2 as TipoPagoV2Enum,
              aplica_home: true,
              estado: true,
              filterByState: false,
              page_size: 1000,
            });

            const entidadesUnicas = new Map<string, EntidadesFinancieras>();
            res.data.data.forEach((fp: IPaymentMethodV2) => {
              if (!entidadesUnicas.has(fp.entidad_financiera)) {
                entidadesUnicas.set(fp.entidad_financiera, {
                  codigo: fp.entidad_financiera,
                  nombre: fp.entidad_financiera,
                } as EntidadesFinancieras);
              }
            });
            setEntidadesV2Filtradas(Array.from(entidadesUnicas.values()));

            // Si hay entidad seleccionada, cargar las formas de pago
            if (dataPreventa.entidad_financiera) {
              const resFP = await getPaymentMethodsV2({
                tipo_pago: dataPreventa.tipo_pago_v2 as TipoPagoV2Enum,
                entidad_financiera: dataPreventa.entidad_financiera,
                aplica_home: true,
                estado: true,
                filterByState: false,
                page_size: 1000,
              });
              setFormasPagoV2Filtradas(resFP.data.data);
            }
          } catch (error) {
            console.error("Error cargando datos V2 para edición:", error);
          } finally {
            setIsLoadingEntidadesV2(false);
          }
        }
      }

      ///* referido
      if (dataPreventa?.tipo_referido == TipoReferidoEnumChoice.CLIENTE) {
        setEsReferido(200);
        reset({
          ...form.getValues(),
          cedula_refiere: dataPreventa.referido_cliente_data?.identificacion,
          nombre_refiere: dataPreventa.referido_cliente_data?.razon_social,
          celular_refiere: dataPreventa.referido_cliente_data?.celular,
          direccion_refiere: dataPreventa.referido_cliente_data?.direccion,
        });
      }

      if (dataPreventa?.tipo_referido == TipoReferidoEnumChoice.FLOTA) {
        setVisibleReferido(true);
        reset({
          ...form.getValues(),
          referido_flota: dataPreventa.referido_flota_data?.codigo,
        });
      }

      if (dataPreventa?.tipo_referido == TipoReferidoEnumChoice.EMPLEADO) {
        setVisibleReferido(true);
        reset({
          ...form.getValues(),
          tipo_referido: dataPreventa.tipo_referido,
          referido_empleado: dataPreventa.referido_empleado,
        });
      }

      // Pasar el codigo_forma_pago explícitamente (V2 tiene prioridad sobre V1)
      const codigoFormaPagoEdit =
        dataPreventa?.forma_pago_v2 || dataPreventa?.forma_pago_data?.codigo;
      await aplicaPromocion(dataPreventa?.plan!, codigoFormaPagoEdit);
    }

    ///* otros
    form.setValue("aplica_gremios", dataProspecto.es_gremio);
    form.setValue("tipo_contribuyente", dataProspecto.tipo_contribuyente);
  };

  ///* Obtener ubicacion cuando es editar, canje o evento

  async function handleUbicacionDefecto(coordenadas: string) {
    let s = coordenadas.split(",");
    setLatLng({ lat: +s?.at(0)!, lng: +s?.at(1)! });
    setCurrentCoordenadas(coordenadas!);
    //onChangeProvince(dataPreventa?.provincia_data?.codigo!);
    await handleVerificarCoordenada(s?.at(0)!, s?.at(1)!);
  }

  ///* formulario
  const schemaPreventaSchema = useMemo(
    () => newPreventaSchema(valorRestriccionCel),
    [valorRestriccionCel]
  );
  const form = useForm<IFormPreventa, any, IFormPreventa>({
    resolver: yupResolver(schemaPreventaSchema as any),
    defaultValues: {
      celular: dataProspecto?.celular || "",
      es_tercera_edad: false,
      es_router_ac: false,
      requiere_wifi_6: false,
      es_android_tv: false,
      es_ups: false,
      numero_cantidad_wifi_6: 0,
      numero_cantidad_router_ac: 0,
      numero_cuotas_router_ac: 0,
      numero_cuotas_wifi_6: 0,
      numero_cantidad_android_tv: 0,
      numero_cuotas_android_tv: 0,
      numero_cuotas_ups: 0,
      numero_cantidad_ups: 0,
      representante_legal_tipo_identificacion:
        TipoIdentificacionEnumChoice.CEDULA,
      tipo_autorizacion_buro: dataProspecto.tipo_identificacion,
    },
  });
  const { reset, setError, clearErrors } = form;

  const getDataProducto = useEquiposAdicionales((s) => s.getDataProducto);
  const productos = useEquiposAdicionales((s) => s.productos);
  const handleAgregarProducto = useEquiposAdicionales(
    (s) => s.handleAgregarProducto,
  );
  const handleEliminarProducto = useEquiposAdicionales(
    (s) => s.handleEliminarProducto,
  );
  const handleActualizarProducto = useEquiposAdicionales(
    (s) => s.handleActualizarProducto,
  );
  const handleClearAllProductos = useEquiposAdicionales(
    (s) => s.handleClearAllProductos,
  );
  const handleSetAllProductos = useEquiposAdicionales(
    (s) => s.handleSetAllProductos,
  );

  ///* react query

  const { data: dataEntidadFinanciero, isLoading: isLoadingEntidadFinanciero } =
    useFetchEntidadesFinancieras({
      page_size: 600,
      enabled: form.watch("forma_pago") == PaymentMethodEnum.TARJETA,
    });

  const { mutateAsync: updatePreventa, isPending: isPendingUpdatePreventa } =
    useUpdatePreventa({
      enableAlert: false,
    });

  const {
    mutateAsync: mutateAsyncCreatePreventa,
    isPending: isPendingPreventa,
  } = useCreatePreventa({
    navigate,
  });

  const fetchGenerarSolicitudCodOtp = usePutFetchCodOtp({
    customMessage: "Solicitud enviado al supervisor de venta.",
  });

  const { mutateAsync: mutateAsyncValidarCodigoOtp } = usePostValidarCodigoOtp(
    {},
  );

  const {
    isPending: isPendingGenerarCoditoOtp,
    mutateAsync: mutateAsyncGenerarCodigoOtp,
  } = useFetchGenerarCodigoOtp();

  const { data: dataFlota, isLoading: isLoadingFlota } = useFetchFlota({
    enabled: form.watch("tipo_referido") === TipoReferidoEnumChoice.FLOTA,
  });

  const { data: dataParamRestriccionCel, isLoading: isLoadingParamRestriccionCel } = useFetchParametros({
    enabled: true,
    params: {
      slug: "RESTRICCION_CELULAR"
    }
  });


  const {
    mutateAsync: fetchCalcularValorInstalacion,
    isPending: isPendingValorInstalacion,
  } = useFetchCalcularValorInstalacion({
    enableSuccessAlert: false,
  });

  const { data: dataCooperativa, isLoading: isLoadingCooperativa } =
    useFetchCooperativa({
      params: {
        entidad_financiera: form.watch("entidad_financiera")!,
        estado: true,
      },
      enabled: !!form.watch("entidad_financiera"),
    });

  const {
    data: dataReferido,
    isPending: isPendingReferido,
    mutateAsync: mutateAsyncEsReferido,
  } = useFetchEsClienteFibramax();

  ///* hook personalizado

  const { handleUploadFile } = useUploadFile();

  const { dataSector, isLoadingSector } = useLocalidad({
    form: form as any,
    cobertura: true,
  });

  const {
    latLng,
    setLatLng,
    Map: MapComponent,
    napsByCity,
    isLoadingNapsByCity,
    setCurrentCoordenadas,
  } = useMapComponent({
    form,
    currentCity: "",
    coordenadasCliente: "",
    enabledFetchNaps: true,
    canUpdateLatLong: true,
    async onChangeMarker(value) {
      if (!value) return;
      handleVerificarCoordenada(value.lat.toString(), value.lng.toString());
    },
  });

  ///* Handle

  const handleVerificarCoordenada = useCallback(
    async (lat: string, lng: string) => {
      try {
        const resp = await postPoligono({
          latitud: lat,
          longitud: lng,
        });
        //onChangeZona(resp.data.codigo);
        reset({
          ...form.getValues(),
          zona: resp.data.codigo,
          ciudad: resp.data.ciudad_data?.codigo,
          provincia: resp.data.provincia_data?.codigo,
          provincia_nombre: resp.data.provincia_data?.nombre,
          ciudad_nombre: resp.data.ciudad_data?.nombre,
          zona_nombre: resp.data.nombre,
        });

        setExisteCobertura(true);
      } catch (error) {
        setExisteCobertura(false);
        reset({
          ...form.getValues(),
          zona: "",
          ciudad: "",
          provincia: "",
          zona_nombre: "",
          provincia_nombre: "",
          ciudad_nombre: "",
        });
      }
    },
    [],
  );

  const handleCoordenadaValida = (
    value: string,
    valid: boolean | undefined,
  ) => {
    if (!valid || !value) return;
    let coord = value.split(",");
    setLatLng({ lat: +coord[0], lng: +coord[1] });
    setCurrentCoordenadas(value);
    handleVerificarCoordenada(coord[0], coord[1]);
    reset({
      ...form.getValues(),
      //plan: ''
    });
  };

  const handleSelectSector = async (cod: string) => {
    // Guardar valores ANTES del reset
    const currentPlan = form.getValues().plan;
    const currentCodigoFormaPago = form.getValues().codigo_forma_pago;

    reset({
      ...form.getValues(),
      tipo_plan: "",
      tipo_servicio: "",
      plan: "",
      promocion: "",
      promocion_nombre: "",
      promociones: [],
    });
    if (cod) form.setValue("sector", cod);

    if (currentPlan) {
      await aplicaPromocion(currentPlan, currentCodigoFormaPago);
    }

    const {
      es_tercera_edad,
      es_discapacitado,
      es_curador_tutor,
      es_ayuda_social,
      es_bono_humano,
      es_gremio,
    } = dataProspecto;

    if (
      es_tercera_edad ||
      es_discapacitado ||
      es_curador_tutor ||
      es_ayuda_social ||
      es_bono_humano ||
      es_gremio ||
      planRRHH
    ) {
      const plan = plans.find(
        (p) =>
          (es_curador_tutor && p.es_curador_tutor) ||
          (es_ayuda_social && p.es_ayuda_social) ||
          (es_bono_humano && p.es_bono_humano) ||
          (es_tercera_edad && p.es_tercera_edad) ||
          (es_discapacitado && p.es_discapacidad) ||
          (es_gremio && p.es_gremio) ||
          (planRRHH && p.es_rrhh),
      );

      console.log("plan", plan);

      if (!plan) return;

      reset({
        ...form.getValues(),
        tipo_plan: plan.tipo_plan,
        tipo_servicio: ServciceTypeEnum.FIBRA,
        plan: plan?.codigo,
        velocidad: plan.velocidad_subida_maxima,
        unidad: plan.unidad,
        valor_plan: plan?.valor,
      });
    }
  };

  async function aplicaPromocion(
    codPlan: string,
    codigoFormaPagoOverride?: string,
  ) {
    // Usar el override si se proporciona, de lo contrario usar el valor del formulario
    const codigoFormaPago =
      codigoFormaPagoOverride ?? form.getValues().codigo_forma_pago;

    const respPromocion = await getAplicaPromocion({
      planes: codPlan,
      ciudades: form.getValues().ciudad,
      provincias: form.getValues().provincia,
      zonas: form.getValues().zona,
      sectores: form.getValues().sector,
      formas_de_pago: codigoFormaPago,
      estado: true,
    });

    if (respPromocion && respPromocion?.length > 0) {
      // =======================================================================
      // Aplica Promoción Gremios
      // =======================================================================
      if (!!form.getValues()?.aplica_gremios) {
        const prom = respPromocion?.find((promo) =>
          promo.nombre.includes("GREMIO"),
        );
        reset({
          ...form.getValues(),
          promocion: prom?.id_promocion,
          promocion_nombre: prom?.nombre,
          promociones: [prom?.id_promocion],
        });
      } else {
        const prom = obtenerPromocionDePrioridadMasBaja(respPromocion);
        if (!prom?.nombre?.includes("GREMIO")) {
          reset({
            ...form.getValues(),
            promocion: prom?.id_promocion,
            promocion_nombre: prom?.nombre,
            promociones: [prom?.id_promocion],
          });
        } else {
          reset({
            ...form.getValues(),
            promocion: "",
            promocion_nombre: "",
            promociones: [],
          });
        }
      }
    } else {
      reset({
        ...form.getValues(),
        promocion: "",
        promocion_nombre: "",
        promociones: [],
      });
    }
  }

  const handleApiUbicacioActual = async () => {
    try {
      const coordenadasApi = await obtenerUbicacion();
      const { latitude, longitude } = coordenadasApi;
      setLatLng({
        lat: latitude,
        lng: longitude,
      });
      setCurrentCoordenadas(`${latitude},${longitude}`);
      reset({
        ...form.getValues(),
        coordenadas: `${latitude},${longitude}`,
        latitud: latitude.toString(),
        longitud: longitude.toString(),
        //plan: ''
      });

      handleVerificarCoordenada(latitude.toString(), longitude.toString());
    } catch (error) {
      console.log(error, "error");
    } finally {
    }
  };

  const handleFormaPago = async (e: IPaymentMethod) => {
    setTipoTarjeta(null);

    // Guardar el plan actual ANTES del reset
    const currentPlan = form.getValues().plan;

    reset({
      ...form.getValues(),
      entidad_financiera: null,
      codigo_forma_pago: "",
      tipo_contrato: "",
      tarjeta: "",
      valor_instalacion_total: "",
      valor_instalacion: "",
      valor_instalacion_iva: "",
      numero_cuenta: "",
      tipo_cuenta_bancaria: "",
      numero_tarjeta: "",
      observacion_1: "",
      forma_pago: "",
    });

    if (!e) return;

    if (e.forma_pago == TipoFormaPagoEnumChoice.DEBITO)
      form.setValue("entidad_financiera", e.entidad_financiera);

    reset({
      ...form.getValues(),
      no_cobrar: false,
      forma_pago: e.forma_pago,
      codigo_forma_pago: e.codigo,
      tipo_contrato: e.tipo_contrato ?? TipoContratoENUM.GEDATECU,
      tarjeta: e.tarjeta,
      numero_cuenta: "",
      tipo_cuenta_bancaria: "",
      numero_tarjeta: "",
      observacion_1: "APLICA PARA TODAS LAS CIUDADES",
      tipo_plan: form.getValues().tipo_plan,
      tarjeta_fecha_caducidad:
        e.forma_pago !== PaymentMethodEnum.TARJETA
          ? null
          : form.getValues().tarjeta_fecha_caducidad,
    });

    handleValorInstalacion();

    // Pasar el codigo_forma_pago explícitamente
    if (currentPlan) {
      await aplicaPromocion(currentPlan, e.codigo);
    }
  };

  // ============ V2 - 3 niveles de pago ============

  // Handler para cuando cambia el Tipo de Pago (DÉBITO/CRÉDITO/RECAUDACIÓN)
  const handleTipoPagoV2Change = async (tipoPago: TipoPagoV2Enum) => {
    setTipoTarjeta(null);

    // Guardar el plan actual ANTES del reset para usarlo después
    const currentPlan = form.getValues().plan;

    // Determinar forma_pago según tipo
    let formaPagoValue: string = "";
    if (tipoPago === TipoPagoV2Enum.DEBITO) {
      formaPagoValue = PaymentMethodEnum.DEBITO;
    } else if (tipoPago === TipoPagoV2Enum.CREDITO) {
      formaPagoValue = PaymentMethodEnum.TARJETA;
    } else if (tipoPago === TipoPagoV2Enum.RECAUDACION) {
      formaPagoValue = TipoFormaPagoEnumChoice.RECAUDACION;
    }

    // Limpiar formulario
    reset({
      ...form.getValues(),
      tipo_pago_v2: tipoPago,
      entidad_financiera: "",
      forma_pago_v2:
        tipoPago === TipoPagoV2Enum.RECAUDACION ? "RECAUDACIÓN" : "", // Para RECAUDACIÓN, setear directamente
      codigo_forma_pago:
        tipoPago === TipoPagoV2Enum.RECAUDACION ? "RECAUDACIÓN" : "",
      forma_pago: formaPagoValue,
      tipo_contrato:
        tipoPago === TipoPagoV2Enum.RECAUDACION
          ? TipoContratoENUM.GEDATECU
          : "",
      tarjeta: "",
      valor_instalacion_total: "",
      valor_instalacion: "",
      valor_instalacion_iva: "",
      numero_cuenta: "",
      tipo_cuenta_bancaria: "",
      numero_tarjeta: "",
      tarjeta_fecha_caducidad: null,
      observacion_1:
        tipoPago === TipoPagoV2Enum.RECAUDACION
          ? "APLICA PARA TODAS LAS CIUDADES"
          : "",
    });

    // Para RECAUDACIÓN, no cargar entidades ni formas de pago
    if (tipoPago === TipoPagoV2Enum.RECAUDACION) {
      setEntidadesV2Filtradas([]);
      setFormasPagoV2Filtradas([]);
      // Calcular valor instalación si hay plan seleccionado
      if (currentPlan) {
        handleValorInstalacion();
        // Pasar "RECAUDACIÓN" como codigo_forma_pago explícitamente
        await aplicaPromocion(currentPlan, "RECAUDACIÓN");
      }
      return;
    }

    // Cargar entidades filtradas por tipo de pago (solo para DÉBITO y CRÉDITO)
    if (tipoPago) {
      setIsLoadingEntidadesV2(true);
      try {
        const res = await getPaymentMethodsV2({
          tipo_pago: tipoPago,
          aplica_home: true,
          estado: true,
          filterByState: false,
          page_size: 1000,
        });

        // Obtener entidades únicas de las formas de pago V2
        const entidadesUnicas = new Map<string, EntidadesFinancieras>();
        res.data.data.forEach((fp: IPaymentMethodV2) => {
          if (!entidadesUnicas.has(fp.entidad_financiera)) {
            entidadesUnicas.set(fp.entidad_financiera, {
              codigo: fp.entidad_financiera,
              nombre: fp.entidad_financiera, // Se usará el código como nombre
            } as EntidadesFinancieras);
          }
        });

        setEntidadesV2Filtradas(Array.from(entidadesUnicas.values()));
        setFormasPagoV2Filtradas([]);
      } catch (error) {
        console.error("Error cargando entidades V2:", error);
        setEntidadesV2Filtradas([]);
      } finally {
        setIsLoadingEntidadesV2(false);
      }
    }
  };

  // Handler para cuando cambia la Entidad Bancaria
  const handleEntidadV2Change = async (entidadCodigo: string) => {
    // Limpiar forma de pago al cambiar entidad
    reset({
      ...form.getValues(),
      entidad_financiera: entidadCodigo,
      forma_pago_v2: "",
      codigo_forma_pago: "",
      numero_cuenta: "",
      tipo_cuenta_bancaria: "",
      numero_tarjeta: "",
      tarjeta_fecha_caducidad: null,
      valor_instalacion_total: "",
      valor_instalacion: "",
      valor_instalacion_iva: "",
    });

    // Cargar formas de pago filtradas
    if (entidadCodigo && form.getValues().tipo_pago_v2) {
      setIsLoadingFormasPagoV2(true);
      try {
        const res = await getPaymentMethodsV2({
          tipo_pago: form.getValues().tipo_pago_v2 as TipoPagoV2Enum,
          entidad_financiera: entidadCodigo,
          aplica_home: true,
          estado: true,
          filterByState: false,
          page_size: 1000,
        });

        let formasPagoFiltradas = res.data.data;

        // Filtro especial para COOP JEP + DÉBITO: solo mostrar "Cuenta de Ahorros"
        // Para CRÉDITO se muestran todas las opciones (Visa, Mastercard, etc.)
        const tipoPagoActual = form.getValues().tipo_pago_v2;
        if (
          entidadCodigo.toUpperCase().includes("JEP") &&
          tipoPagoActual === TipoPagoV2Enum.DEBITO
        ) {
          formasPagoFiltradas = formasPagoFiltradas.filter(
            (fp: IPaymentMethodV2) =>
              fp.nombre.toLowerCase().includes("ahorro"),
          );
        }

        setFormasPagoV2Filtradas(formasPagoFiltradas);
      } catch (error) {
        console.error("Error cargando formas de pago V2:", error);
        setFormasPagoV2Filtradas([]);
      } finally {
        setIsLoadingFormasPagoV2(false);
      }
    }
  };

  // Función auxiliar para mapear nombre de forma de pago a tipo de cuenta bancaria
  const mapFormaPagoToTipoCuenta = (nombreFormaPago: string): string => {
    const nombreLower = nombreFormaPago.toLowerCase();
    if (nombreLower.includes("amiga")) return "AMIGA";
    if (nombreLower.includes("corriente")) return "CORRIENTE";
    if (nombreLower.includes("ahorro")) return "AHORRO";
    return ""; // Por defecto vacío si no coincide
  };

  // Handler para cuando se selecciona una Forma de Pago V2
  const handleFormaPagoV2Change = async (formaPago: IPaymentMethodV2) => {
    setTipoTarjeta(null);
    setSelectedCardTypeName(null);

    if (!formaPago) {
      reset({
        ...form.getValues(),
        forma_pago_v2: "",
        codigo_forma_pago: "",
      });
      return;
    }

    // Guardar el plan actual ANTES del reset para usarlo después
    const currentPlan = form.getValues().plan;

    // Guardar el nombre del tipo de tarjeta si es CRÉDITO
    if (formaPago.tipo_pago === TipoPagoV2Enum.CREDITO) {
      setSelectedCardTypeName(formaPago.nombre);
    }

    // Mapeo automático de tipo_cuenta_bancaria basado en el nombre de la forma de pago (solo para DÉBITO)
    const tipoCuentaAutomatico =
      formaPago.tipo_pago === TipoPagoV2Enum.DEBITO
        ? mapFormaPagoToTipoCuenta(formaPago.nombre)
        : "";

    reset({
      ...form.getValues(),
      forma_pago_v2: formaPago.codigo,
      codigo_forma_pago: formaPago.codigo,
      forma_pago:
        formaPago.tipo_pago === TipoPagoV2Enum.DEBITO
          ? PaymentMethodEnum.DEBITO
          : PaymentMethodEnum.TARJETA,
      forma_pago_legacy: formaPago.forma_pago_legacy || null, // Mapeo a V1 para compatibilidad
      tarjeta: formaPago.forma_pago_legacy_data?.tarjeta || null, // Tarjeta desde V1 legacy
      tipo_contrato: TipoContratoENUM.GEDATECU,
      no_cobrar: false,
      numero_cuenta: "",
      tipo_cuenta_bancaria: tipoCuentaAutomatico, // Mapeo automático basado en el nombre de la forma de pago
      numero_tarjeta: "",
      observacion_1: "APLICA PARA TODAS LAS CIUDADES",
    });

    // Calcular valor instalación
    handleValorInstalacion();

    // Aplicar promoción si hay plan seleccionado
    // Pasar el codigo_forma_pago explícitamente porque form.getValues() no tiene el valor actualizado inmediatamente después del reset
    if (currentPlan) {
      await aplicaPromocion(currentPlan, formaPago.codigo);
    }
  };

  // ============ Fin V2 ============

  const handleValorInstalacion = async () => {
    let valor_instalacion_total = "0";
    let valor_instalacion = "0";
    let valor_instalacion_iva = "0";

    switch (form.getValues().tipo_servicio) {
      case TipoServicioEnumChoice.FIBRA:
        const resp = await fetchCalcularValorInstalacion({
          id_prospecto: dataProspecto?.id_prospecto!,
          forma_pago: form.getValues().forma_pago!,
          score: +dataProspecto?.puntaje_score_empresa!,
          segmentacion: dataProspecto?.segmentacion!,
        });

        const valueInstlacion = resp.data;

        valor_instalacion_total = (
          valueInstlacion.valor_instalacion + valueInstlacion.iva
        ).toFixed(2);
        valor_instalacion = valueInstlacion.valor_instalacion.toFixed(2); //valor sin iva
        valor_instalacion_iva = (
          valueInstlacion.valor_instalacion + valueInstlacion.iva
        ).toFixed(2);
        break;
      case TipoServicioEnumChoice.RADIO:
        valor_instalacion_total = ValorRadioBase.toFixed(2);
        valor_instalacion = (
          ValorRadioBase -
          ValorRadioBase * IvaENUM.IVA
        ).toFixed(2); //valor sin iva
        valor_instalacion_iva = ValorRadioBase.toFixed(2);

        break;
      default:
        break;
    }

    reset({
      ...form.getValues(),
      valor_instalacion_total,
      valor_instalacion,
      valor_instalacion_iva,
    });
  };

  // Mapeo de nombres de tarjeta a tipos de card-validator
  const cardTypeMapping: Record<string, string> = {
    Visa: "visa",
    Mastercard: "mastercard",
    Discover: "discover",
    Diners: "diners-club",
  };

  const handleValidarTarjeta = (numeroTarjeta: string) => {
    const numberValidation = CardValidator.number(numeroTarjeta);

    // Detectar tipo de tarjeta de forma reactiva (incluso con números parciales)
    if (numberValidation.card) {
      setTipoTarjeta(numberValidation.card.type);

      // Validar que el tipo de tarjeta coincida con el seleccionado - REACTIVO
      if (selectedCardTypeName) {
        const expectedCardType = cardTypeMapping[selectedCardTypeName];
        const detectedCardType = numberValidation.card.type;

        if (expectedCardType && detectedCardType !== expectedCardType) {
          setError("numero_tarjeta", {
            message: `Debe ingresar una tarjeta ${selectedCardTypeName}. Se detectó: ${numberValidation.card.niceType}`,
          });
          return;
        }
      }
    } else {
      setTipoTarjeta("");
    }

    // Validar formato completo solo si tiene suficientes dígitos
    if (numeroTarjeta.length >= 13) {
      if (!numberValidation.isValid) {
        const mensajeError = selectedCardTypeName
          ? `Ingrese un número de tarjeta válido para: ${selectedCardTypeName}`
          : "Ingresar una tarjeta válida";
        setError("numero_tarjeta", {
          message: mensajeError,
        });
        return;
      }
    }

    clearErrors("numero_tarjeta");
  };

  const handleSelectPlan = async (plan: Plan) => {
    // Guardar el codigo_forma_pago ANTES del reset para usarlo después
    const currentCodigoFormaPago = form.getValues().codigo_forma_pago;

    reset({
      ...form.getValues(),
      promocion: "",
      es_android_tv: false,
      numero_cuotas_android_tv: 0,
      numero_cantidad_android_tv: 0,
    });

    if (plan) {
      reset({
        ...form.getValues(),
        velocidad: plan.velocidad_subida_maxima,
        unidad: plan.unidad,
        valor_plan: plan.valor,
      });

      // Pasar el codigo_forma_pago explícitamente para asegurar que se use el valor correcto
      await aplicaPromocion(plan.codigo, currentCodigoFormaPago);

      handleValorInstalacion();
    }
  };

  function resetReferido() {
    setEsReferido(404);
    reset({
      ...form.getValues(),
      nombre_refiere: null,
      celular_refiere: null,
      direccion_refiere: null,
      referido_flota: null,
      codigo_refiere: null,
      estado_referido: null,
    });
  }
  async function handleBuscarReferido(identificacion: string) {
    try {

      if (!identificacion) return resetReferido();

      if (identificacion.length != 10 && identificacion.length != 13)
        return resetReferido();

      if (
        (identificacion.length === 10 || identificacion.length === 13) &&
        identificacion === dataProspecto?.identificacion
      ) {
        resetReferido();
        return setAlert(
          true,
          "El cliente no puede referirse a sí mismo.",
          AlertSeverityEnum.warning,
        );
      }

      if (identificacion.length === 10 || identificacion.length === 13) {
        const resp = await mutateAsyncEsReferido({
          identificacion,
        });

        setEsReferido(resp.code);

        if (resp.code != 200) return resetReferido();

        const referido = resp.data;

        let nombreReferido: string = referido.razon_social;

        if (!referido.razon_social) {
          const referidoSRI = await searchDataByCedulaDirecto({
            identificacion,
            verificar_cliente: true,
          });
          nombreReferido = referidoSRI.data.razon_social;
        }

        reset({
          ...form.getValues(),
          email_referido: referido.email,
          nombre_refiere: nombreReferido,
          cedula_refiere: identificacion,
          direccion_refiere: referido.direccion,
          celular_refiere: referido.celular,
          codigo_refiere: referido.codigo, //codigo del cliente
          estado_referido: "PENDIENTE",
        });
      }
    } catch (error) {
      reset({
        ...form.getValues(),
        nombre_refiere: "",
        celular_refiere: "",
        direccion_refiere: "",
        referido_flota: "",
        estado_referido: null,
      });

      setEsReferido(404);
    } finally {
    }
  }

  const handleEstadoCodOTP = async () => {
    try {
      const resp = await getProspectoByIdProspecto(dataProspecto.id_prospecto!);

      if (!resp.codigo_otp_data)
        return setAlert(
          true,
          "Por favor, envia un codigo OTP para validar el celular del cliente.",
          AlertSeverityEnum.warning,
        );

      const valido = resp.codigo_otp_data.validado;
      setAlert(
        true,
        valido
          ? "Celular verificiado por código OTP"
          : "Celular pendiente verificación",
        valido ? AlertSeverityEnum.success : AlertSeverityEnum.warning,
      );

      setValidoCodigoOTP(valido);
    } catch (error) {
      //handleAxiosError(error)
    }
  };

  async function handleGenerarOTP() {
    const isCelularValid = await form.trigger("celular");

    if (!isCelularValid) {
      const errorMessage =
        form.formState.errors.celular?.message ||
        "El número de celular no es válido";
      toast.error(errorMessage);
      return;
    }

    toast.info("Generando código OTP, por favor espere...");
    
    try {
      const respGenerarCodigo = await mutateAsyncGenerarCodigoOtp({
        celular: form.getValues().celular.replace(/^0/, "593"),
        identificacion: dataProspecto?.identificacion!,
      });
      if (respGenerarCodigo.code == 200) {
        setIdCodigoSMS(respGenerarCodigo.data.id_codigo_otp);
        setOpenOtp(true);
        handleStartTimer();
      }
    } catch (error) {
      // Error manejado en onError de la mutación
    }
  }

  function handleStartTimer() {
    const countdownInterval = setInterval(() => {
      setCountdown((te) => te - 1);
    }, 1000);

    setCountdownInterval(countdownInterval);
    const timeoutId = setTimeout(() => {
      setOpenOtp(false);
      setValueOtp("");
      setCountdown(600);
      clearInterval(countdownInterval);
      clearTimeout(timeoutId);

      setAlert(true, "Tiempo terminado", AlertSeverityEnum.error);
    }, 600000);

    setTimeoutId(timeoutId);
  }

  const handleCambiarCelular = async (value: string) => {
    if (value.length === 10 && value.startsWith("09")) {
      clearErrors("celular");
    }
    if (value.length == 10 && dataProspecto?.celular != value) {
      await updateProspecto({
        id: dataProspecto?.id_prospecto!,
        data: {
          celular: form.getValues().celular,
          codigo_otp: null,
        },
      });
    }
  };

  const handleVerificarCodOTP = async () => {
    try {
      if (!valueOtp) {
        setAlert(true, "Ingresar un codigo OTP", AlertSeverityEnum.error);
        return;
      }
      const respCodigo = await mutateAsyncValidarCodigoOtp({
        codigo: valueOtp,
        identificacion: dataProspecto?.identificacion!,
      });

      if (respCodigo.code == 200) {
        setValidoCodigoOTP(true);
        await putCodigoOTP({
          validado: true,
          id_codigo_otp: idCodigoSMS!,
          //estado_solicitud: EstadosSolicitudEnumChoice.APROBADO,
        });

        handleResetiarTimer();
      }
    } catch (error) {
    } finally {
    }
  };

  const handleCancelarCodOTP = async () => {
    reset({
      ...form.getValues(),
      celular: dataProspecto?.celular,
    });

    await updateProspecto({
      id: dataProspecto?.id_prospecto!,
      data: {
        codigo_otp: null,
      },
    });

    handleResetiarTimer();
  };

  const handleEnviarSolicitudOTP = async () => {
    const respSolicitud = await fetchGenerarSolicitudCodOtp.mutateAsync({
      validado: false,
      id_codigo_otp: idCodigoSMS!,
      estado_otp: EstadoOTPChoiceEnum.SOLICITADO,
    });

    if (respSolicitud.code == 200) return handleResetiarTimer();
  };

  const handleResetiarTimer = () => {
    setOpenOtp(false);
    setValueOtp("");
    setCountdown(600);
    clearInterval(countdownInterval!);
    clearTimeout(timeoutId!);
  };

  const handleOnSubmit = async (formPreventa: IFormPreventa) => {
    if (!formPreventa.coordenadas)
      return setAlert(
        true,
        "Campo coordenadas obligatorio",
        AlertSeverityEnum.error,
      );

    ///* validar codito OTP
    if (!validoCodigoOTP)
      return setAlert(true, "Validar Codigo OTP", AlertSeverityEnum.error);

    ///* validar cobertura
    if (!existeCobertura)
      return setAlert(
        true,
        "Lo sentimos, no existe cobertura para las coordenas asignadas",
        AlertSeverityEnum.error,
      );

    ///* validar si existe nap para fibra
    if (
      napsByCity.length == 0 &&
      form.getValues().tipo_servicio == TipoServicioEnumChoice.FIBRA
    )
      return setAlert(
        true,
        `No hay NAP encotradas para las coordenedas asignadas.`,
        AlertSeverityEnum.error,
      );

    ///* validar imagens para debito bancario y tarjeta (usando tipo_pago_v2)
    if (
      form.getValues().tipo_pago_v2 === TipoPagoV2Enum.DEBITO &&
      !dataPreventa?.url_foto_cuenta_bancaria &&
      !imgCuentaBancaria
    )
      return setAlert(
        true,
        'Pendiente subir "Foto de la Cuenta Bancaria"',
        AlertSeverityEnum.error,
      );

    if (
      form.getValues().tipo_pago_v2 === TipoPagoV2Enum.CREDITO &&
      !dataPreventa?.url_foto_tarjeta &&
      !imgTarjeta
    ) {
      return setAlert(
        true,
        'Pendiente subir "Foto del Número de Tarjeta"',
        AlertSeverityEnum.error,
      );
    }

    ///* validar documentos

    const formaPago = form.getValues().forma_pago;

    const imageDoc = [
      ///* documentos obligatorios
      {
        tipo: DocKey.IDENTIFICACION_FRONTAL,
        file: imgCedulaFrontal,
        url: dataPreventa?.url_foto_identificacion_delantera,
      },
      {
        tipo: DocKey.IDENTIFICACION_REVERSO,
        file: imgCedulaReverso,
        url: dataPreventa?.url_foto_identificacion_posterior,
      },

      ///* documentos para cuando es ruc, sociedad
      ...(dataProspecto.tipo_identificacion == TipoIdentificacionEnumChoice.RUC
        ? [
          {
            tipo: DocKey.RUC,
            file: imgRUC,
            url: dataPreventa?.url_foto_ruc,
          },
        ]
        : []),
      ...(dataProspecto.tipo_identificacion ==
        TipoIdentificacionEnumChoice.RUC &&
        dataProspecto.tipo_contribuyente !=
        TipoContribuyenteRucChoice.PERSONA_NATURAL
        ? [
          {
            tipo: DocKey.NOMBRAMIENTO,
            file: imgRUCNombramiento,
            url: dataPreventa?.url_foto_nombramiento,
          },
        ]
        : []),

      ///* forma de pago
      ...(formaPago === PaymentMethodEnum.DEBITO
        ? [
          {
            tipo: DocKey.DEBITO,
            file: imgCuentaBancaria,
            url: dataPreventa?.url_foto_cuenta_bancaria,
          },
        ]
        : []),
      ...(formaPago === PaymentMethodEnum.TARJETA
        ? [
          {
            tipo: DocKey.TARJETA,
            file: imgTarjeta,
            url: dataPreventa?.url_foto_tarjeta,
          },
        ]
        : []),
    ];

    const docsInvalidos = imageDoc.filter((doc) => !doc.file && !doc.url);

    if (docsInvalidos.length > 0) {
      toast.error("Faltan documentos obligatorios");
      return;
    }

    const [
      doc_identificacion_frontal,
      doc_identificacion_reverso,
      doc_ruc,
      doc_nombramiento,
      doc_cuenta_bancaria,
      doc_tarjeta,
    ] = await Promise.all([
      handleUploadFile(imgCedulaFrontal, BucketAwtENUM.IMAGE_IDENTIFICACION),
      handleUploadFile(imgCedulaReverso, BucketAwtENUM.IMAGE_IDENTIFICACION),
      handleUploadFile(imgRUC, BucketAwtENUM.IMAGE_IDENTIFICACION),
      handleUploadFile(imgRUCNombramiento, BucketAwtENUM.IMAGE_IDENTIFICACION),
      handleUploadFile(imgCuentaBancaria, BucketAwtENUM.IMAGE_IDENTIFICACION),
      handleUploadFile(imgTarjeta, BucketAwtENUM.IMAGE_IDENTIFICACION),
    ]);

    formPreventa.url_foto_identificacion_delantera =
      dataPreventa?.url_foto_identificacion_delantera ??
      doc_identificacion_frontal.url;

    formPreventa.url_foto_identificacion_posterior =
      dataPreventa?.url_foto_identificacion_posterior ??
      doc_identificacion_reverso.url;

    formPreventa.url_foto_ruc = dataPreventa?.url_foto_ruc ?? doc_ruc.url;

    formPreventa.url_foto_nombramiento =
      dataPreventa?.url_foto_nombramiento ?? doc_nombramiento.url;

    formPreventa.url_foto_cuenta_bancaria =
      dataPreventa?.url_foto_cuenta_bancaria ?? doc_cuenta_bancaria.url;

    formPreventa.url_foto_tarjeta =
      dataPreventa?.url_foto_tarjeta ?? doc_tarjeta.url;

    ///* Editar preventa
    if (editSupervisor) {
      delete formPreventa.codigo;
      const resp = await updatePreventa({
        id: dataPreventa?.id_preventa!,
        data: {
          ...formPreventa,
          equipos_adicionales: productos,
          // V2: Usar forma_pago_legacy para mantener compatibilidad con V1
          forma_pago: form.getValues().forma_pago_legacy || null,
          // Para RECAUDACIÓN, forma_pago_v2 debe ser null (no hay FK de FormaPagoV2 para RECAUDACIÓN)
          forma_pago_v2:
            form.getValues().tipo_pago_v2 === TipoPagoV2Enum.RECAUDACION
              ? "RECAUDACIÓN"
              : form.getValues().forma_pago_v2 || "RECAUDACIÓN",
          tipo_pago_v2: form.getValues().tipo_pago_v2,
          email:
            form.getValues().servicio_correo != emailENUM.MANUALMENTE
              ? `${form.getValues().email_temporal}${form.getValues().servicio_correo
              }`
              : form.getValues().email_temporal,
          cambiar_referido:
            form.getValues().codigo_refiere == referidoTemp ? false : true,
          tipo_referido: form.getValues().tipo_referido,
          referido_cliente: form.getValues().codigo_refiere ?? "",
          generar_pdf_contrato: true,
        } as any,
      });

      if (resp.code === 200) {
        navigate(ROUTER_PATHS.ventas.preventasNav);
        setAlert(
          true,
          "Datos actualizados correctamente.",
          AlertSeverityEnum.success,
        );
      }
      return;
    }

    try {
      formPreventa.equipos_adicionales = productos;
      ///* validar datos
      formPreventa.tipo_referido = form.getValues().tipo_referido ?? null;
      formPreventa.referido_cliente = form.getValues().codigo_refiere ?? null;
      formPreventa.referido_empleado =
        form.getValues().referido_empleado ?? null;

      formPreventa.observaciones = {
        observacion_1: form.getValues().observacion_1 ?? "",
        observacion_2: form.getValues().observacion_2 ?? "",
      };
      formPreventa.promociones = [
        form.getValues().promocion ?? "",
        form.getValues().promocion_2 ?? "",
        form.getValues().promocion_3 ?? "",
      ].filter((e) => e !== "");

      formPreventa.condicion_residencia = dataProspecto?.residencia_permanente
        ? "PERMANENTE"
        : "NO PERMANENTE";
      formPreventa.prospecto = dataProspecto?.codigo;
      formPreventa.email =
        form.getValues().servicio_correo != emailENUM.MANUALMENTE
          ? `${form.getValues().email_temporal}${form.getValues().servicio_correo
          }`
          : form.getValues().email_temporal;

      ///* valor de instalacion

      const esEventoCanje = [
        TipoSolicitudesEnum.CANJE,
        TipoSolicitudesEnum.EVENTO,
        TipoSolicitudesEnum.EVENTO_GRATUITO,
        TipoSolicitudesEnum.EVENTO_PAGADO,
      ].includes(handleValidarTipoVenta as TipoSolicitudesEnum);

      let valor_instalacion_total =
        form.getValues().tipo_servicio === TipoServicioEnumChoice.RADIO
          ? ValorRadioBase.toString()
          : form.getValues().valor_instalacion_total;
      let valor_instalacion =
        form.getValues().tipo_servicio === TipoServicioEnumChoice.RADIO
          ? (ValorRadioBase - ValorRadioBase * IvaENUM.IVA).toFixed(2)
          : form.getValues().valor_instalacion;
      let valor_instalacion_iva =
        form.getValues().tipo_servicio === TipoServicioEnumChoice.RADIO
          ? ValorRadioBase.toString()
          : form.getValues().valor_instalacion_iva;

      ///* cuando es canje/evento el valor de instalacion es cero y requiere contrato fisico
      if (esEventoCanje) {
        valor_instalacion_total = "0";
        valor_instalacion = "0";
        valor_instalacion_iva = "0";
        formPreventa.pre_requiere_contrato_fisico = true;
      }

      formPreventa.valor_instalacion_total = valor_instalacion_total;
      formPreventa.valor_instalacion = valor_instalacion;
      formPreventa.valor_instalacion_iva = valor_instalacion_iva;

      // V2: Usar forma_pago_legacy para mantener compatibilidad con V1
      formPreventa.forma_pago =
        form.getValues().forma_pago_legacy || (null as any);
      // Para RECAUDACIÓN, forma_pago_v2 debe ser null (no hay FK de FormaPagoV2 para RECAUDACIÓN)
      formPreventa.forma_pago_v2 =
        form.getValues().tipo_pago_v2 === TipoPagoV2Enum.RECAUDACION
          ? ("RECAUDACIÓN" as any)
          : form.getValues().forma_pago_v2 || "RECAUDACIÓN";
      formPreventa.tipo_pago_v2 = form.getValues().tipo_pago_v2!;
      formPreventa.tipo_autorizacion_debito =
        form.getValues().tipo_autorizacion_buro;
      await mutateAsyncCreatePreventa(formPreventa);
    } catch (error) {
      //handleRollBack(formPreventa, error);
    } finally {
      //setIsGlobalLoading(false);
    }
  };

  const handlePlanes = (): Plan[] => {
    const { tipo_servicio, tipo_plan } = form.getValues();

    if (planRRHH) {
      return plans.filter(
        (e) =>
          e.tipo_servicio == tipo_servicio &&
          e.tipo_plan == tipo_plan &&
          e.es_rrhh == planRRHH,
      );
    }

    if (form.getValues().aplica_gremios) {
      return plans.filter(
        (e) =>
          e.tipo_servicio == tipo_servicio &&
          e.tipo_plan == tipo_plan &&
          e.es_gremio,
      );
    }

    if (dataProspecto.es_ayuda_social) {
      return plans.filter(
        (e) =>
          e.tipo_servicio == tipo_servicio &&
          e.tipo_plan == tipo_plan &&
          e.es_ayuda_social,
      );
    }

    if (dataProspecto.es_bono_humano) {
      return plans.filter(
        (e) =>
          e.tipo_servicio == tipo_servicio &&
          e.tipo_plan == tipo_plan &&
          e.es_bono_humano,
      );
    }

    if (planDiscTerEdad || dataProspecto.es_curador_tutor) {
      return plans.filter(
        (e) =>
          e.tipo_servicio == tipo_servicio &&
          e.tipo_plan == tipo_plan &&
          (e.es_tercera_edad || e.es_discapacidad),
      );
    }

    return plans.filter(
      (e) =>
        e.tipo_servicio == tipo_servicio &&
        e.tipo_plan == tipo_plan &&
        !e.es_tercera_edad &&
        !e.es_discapacidad &&
        !e.es_bono_humano &&
        !e.es_ayuda_social &&
        !e.es_gremio &&
        !e.es_rrhh,
    );
  };

  const handleBuscarRepresententeLegal = useCallback(async () => {
    try {
      const resp = await searchDataByCedulaDirecto({
        identificacion: form.getValues().representante_legal_identificacion!,
      });
      if (resp.code != 200) return;
      const data = resp.data;
      form.setValue(
        "representante_legal_razon_social",
        data.nombre ?? data.razonSocial,
      );
      setAlert(
        true,
        "Representante legal es valido.",
        AlertSeverityEnum.success,
      );
    } catch (error) {
      setAlert(
        true,
        "Ingresar un representante legal valido.",
        AlertSeverityEnum.error,
      );
      form.setValue("representante_legal_razon_social", null);
    }
  }, []);

  const handleValidarTipoVenta = useMemo(() => {
    if (dataProspecto.solictud_canje_data) {
      return TipoSolicitudesEnum.CANJE;
    }
    if (dataProspecto.solictud_evento_data) {
      return dataProspecto.solictud_evento_data.tipo_evento ?? "N/A";
    }
    return TipoSolicitudesEnum.HOGAR;
  }, [dataProspecto.id_prospecto]);

  ///* effect
  useEffect(() => {
    return () => {
      handleClearAllProductos();
      clearInterval(countdownInterval!);
      clearTimeout(timeoutId!);
    };
  }, []);

  useEffect(() => {
    handleCargaInicial();

    return () => {
      setPlanDiscTerEdad(false);
      reset({});
    };
  }, [dataProspecto.id_prospecto]);

  useEffect(() => {
    if (!isLoadingSector) {
      form.setValue("sector", dataPreventa?.sector_data?.codigo!);
    }
  }, [isLoadingSector]);

  useEffect(() => {
    if (!isLoadingParamRestriccionCel) {

      const value = dataParamRestriccionCel?.data?.data?.[0]?.valor;
      console.log(value);

      setValorRestriccionCel(
        value
          ? JSON.parse(value)
          : {}
      );
    }
  }, [isLoadingParamRestriccionCel, dataParamRestriccionCel])

  useLoaders(isPendingGenerarCoditoOtp || isPendingValorInstalacion);

  return {
    form,
    handleValidarTipoVenta,

    ///* tab residencia
    modalMapa,
    setModalMapa,
    MapComponent,
    latLng,
    setLatLng,
    napsByCity,
    isLoadingNapsByCity,
    existeCobertura,
    dataSector: dataSector?.data.data,
    isLoadingSector,
    dataProspecto,
    handleCoordenadaValida,
    handleSelectSector,
    handleApiUbicacioActual,
    handleBuscarRepresententeLegal,

    ///* tab servicio
    handleFormaPago,
    isPendingValorInstalacion,
    dataCooperativa: dataCooperativa?.data.data,
    isLoadingCooperativa,
    handleValidarTarjeta,
    tipoTarjeta,
    planDiscTerEdad,
    handleSelectPlan,
    visibleReferido,
    setVisibleReferido,
    isLoadingEntidadFinanciero,
    dataEntidadFinanciero,
    handlePlanes,
    handleValorInstalacion,

    // V2 - 3 niveles de pago
    handleTipoPagoV2Change,
    handleEntidadV2Change,
    handleFormaPagoV2Change,
    entidadesV2Filtradas,
    isLoadingEntidadesV2,
    formasPagoV2Filtradas,
    isLoadingFormasPagoV2,

    ///* tab otros servicios
    handleBuscarReferido,
    esReferido,
    isPendingReferido,
    setEsReferido,
    dataReferido,
    dataFlota,
    isLoadingFlota,
    getDataProducto,
    productos,
    handleActualizarProducto,
    handleAgregarProducto,
    handleEliminarProducto,

    ///* tab documentos
    imgCedulaFrontal,
    setImgCedulaFrontal,
    imgCedulaReverso,
    setImgCedulaReverso,
    imgCuentaBancaria,
    setImgCuentaBancaria,
    imgTarjeta,
    setImgTarjeta,
    imgRUC,
    setImgRUC,
    imgRUCNombramiento,
    setImgRUCNombramiento,
    handleEstadoCodOTP,
    handleGenerarOTP,
    openOtp,
    handleCambiarCelular,
    countdown,
    valueOtp,
    setValueOtp,
    handleVerificarCodOTP,
    handleCancelarCodOTP,
    handleEnviarSolicitudOTP,
    handleOnSubmit,
    isPendingPreventa,
    isPendingUpdatePreventa,
    valorRestriccionCel,
    fetchAutocompleteEmpleado,
  };
};
